var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9669 1.40212C16.0138 1.21306 16.011 1.01508 15.9589 0.827399C15.9067 0.639716 15.8069 0.468706 15.6692 0.330964C15.5314 0.193222 15.3604 0.0934271 15.1727 0.0412655C14.9851 -0.0108962 14.7871 -0.0136538 14.598 0.0332611L0.755571 4.64741C0.549292 4.71327 0.36737 4.83921 0.233104 5.0091C0.0988386 5.17898 0.0183429 5.38508 0.00192731 5.601C-0.0108254 5.81676 0.0399197 6.03153 0.147891 6.21877C0.255861 6.40601 0.416327 6.55752 0.609457 6.65456L6.43866 9.56147L9.34557 15.3907C9.40144 15.4946 9.4713 15.5903 9.55321 15.6752C9.66344 15.7857 9.79581 15.8716 9.9416 15.9272C10.0874 15.9829 10.2433 16.0071 10.3991 15.9982C10.6151 15.9818 10.8211 15.9013 10.991 15.767C11.1609 15.6328 11.2869 15.4508 11.3527 15.2446L15.9669 1.40212Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.853ed5727d36b5a170a627125598d104.svg";
export { ForwardRef as ReactComponent };